import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  '@global': {
    html: {
      height: '100%',
      width: '100%',
      boxSizing: 'border-box',
      padding: '0 !important',
    },
    body: {
      margin: 0,
      padding: 0,
      height: '100%',
      width: '100%',
    },
    '#root': {
      height: '100%',
      width: '100%',
    },
  },
});

export default useStyles;
